import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Auth disabled — set a placeholder user so the app loads without login.
  // To re-enable: restore the axios.get("/api/auth/me") call below.
  const [user, setUser] = useState({ email: "", role: "admin" });

  // Disabled: axios.get(`${API}/api/auth/me`).then(r => setUser(r.data)).catch(() => setUser(null));

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true }).catch(() => {});
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() { return useContext(AuthContext); }
